import { FormControl, FormLabel, Grid, MenuItem, Select } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function DayOfWeekField(props) {
    const { value, onChange } = props;
    const { t } = useTranslation();

    return (
        <Grid item>
            <FormLabel>{t('recurrence.field.dayOfWeek.label')}</FormLabel>
            <br/>
            <FormControl sx={{m: 1, minWidth: 150}}>
                <Select
                    value={value}
                    onChange={onChange}
                >
                    <MenuItem value={''}>
                        <em>{t('recurrence.field.dayOfWeek.selectDay')}</em>
                    </MenuItem>
                    <MenuItem value={0}>{t('recurrence.day.sunday')}</MenuItem>
                    <MenuItem value={1}>{t('recurrence.day.monday')}</MenuItem>
                    <MenuItem value={2}>{t('recurrence.day.tuesday')}</MenuItem>
                    <MenuItem value={3}>{t('recurrence.day.wednesday')}</MenuItem>
                    <MenuItem value={4}>{t('recurrence.day.thursday')}</MenuItem>
                    <MenuItem value={5}>{t('recurrence.day.friday')}</MenuItem>
                    <MenuItem value={6}>{t('recurrence.day.saturday')}</MenuItem>
                </Select>
            </FormControl>

        </Grid>

    )
}

DayOfWeekField.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
};
